// webapp/src/AppLayout.js
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import { useAuth } from './AuthContext';
import AppHeader from './AppHeader';

function AppLayout() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate("/login");
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  return (
    <div className="app-container">
      <AppHeader currentUser={currentUser} onSignOut={handleSignOut} />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;